module.exports = __webpack_public_path__ + "img/hy-logo3.11d85761.png";